import palette from '../palette';

export default {
  root: {
    borderBottom: `2px solid ${palette.disabled.main}`,
  },
};